class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;
    this.addEventListener('keyup', (event) => { if (event.code === 'Escape') this.close(); });
    this.addEventListener('click', (event) => {
      if (event.target.closest('#CartDrawer-Overlay')) { this.close(); return; }
      const minus = event.target.closest('[data-cart-qty-minus]');
      const plus = event.target.closest('[data-cart-qty-plus]');
      if (minus || plus) {
        event.preventDefault();
        const index = (minus || plus).dataset.index;
        const input = this.querySelector('#Drawer-quantity-' + index);
        if (!input) return;
        const step = parseInt(input.step || '1', 10) || 1;
        const min = parseInt(input.min || '0', 10) || 0;
        const max = input.max ? parseInt(input.max, 10) : Infinity;
        let value = parseInt(input.value || '0', 10);
        value = plus ? Math.min(max, value + step) : Math.max(min, value - step);
        if (value !== parseInt(input.value || '0', 10)) {
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => { event.preventDefault(); this.open(cartLink); });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE' || event.code.toUpperCase() === 'ENTER') {
        event.preventDefault(); this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    requestAnimationFrame(() => { this.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); });
    setTimeout(() => {
      const drawer = this.querySelector('.drawer__inner');
      if (drawer && typeof trapFocus === 'function') trapFocus(drawer, drawer);
    }, 300);
  }
  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    if (this.activeElement && typeof this.activeElement.focus === 'function') this.activeElement.focus();
  }
  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    this.getSectionsToRender().forEach((section) => {
      const sourceHTML = parsedState.sections[section.id];
      if (!sourceHTML) return;
      const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!target) return;
      const newHTML = this.getSectionInnerHTML(sourceHTML, section.selector);
      if (newHTML) target.innerHTML = newHTML;
    });
    setTimeout(() => { this.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }, 30);
  }
  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);
    return element ? element.innerHTML : '';
  }
  setActiveElement(element) { this.activeElement = element; }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }

  /*
    Samengevoegde regels (bv. Kaching "Koop 2 + 1 Gratis"): Shopify splitst één product over
    meerdere regels. De winkelmand toont ze als één regel; bij een nieuw aantal zetten we het
    totaal op de eerste regel en de rest op 0. Shopify past de korting daarna zelf opnieuw toe.
  */
  updateQuantity(line, quantity, name, variantId) {
    const input = this.querySelector('#Drawer-quantity-' + line);
    const keys = input && input.dataset.groupKeys ? input.dataset.groupKeys.split(',').filter(Boolean) : [];
    if (keys.length < 2) return super.updateQuantity(line, quantity, name, variantId);

    this.enableLoading(line);
    const updates = {};
    keys.forEach((key, i) => { updates[key] = i === 0 ? parseInt(quantity, 10) || 0 : 0; });

    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(routes.cart_update_url, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((state) => {
        if (state.errors || state.status) {
          const errorText = this.querySelector('#CartDrawer-LineItemError-' + line + ' .cart-item__error-text');
          if (errorText) errorText.textContent = state.description || state.message || window.cartStrings.error;
          if (input) input.value = input.getAttribute('value');
          return;
        }
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        this.classList.toggle('is-empty', state.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', state.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const container = document.getElementById(section.id);
          if (!container || !state.sections || !state.sections[section.section]) return;
          const target = container.querySelector(section.selector) || container;
          target.innerHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
        });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state, variantId });
        }
      })
      .catch(() => {
        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
}
if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);
